import React, { useEffect, useState } from 'react'
import { uid } from '@zera-admin/utils'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import Button, { ButtonGroup, LinkButton } from '@zera-admin/button'
import Page, { PageHeader, Container } from '@zera-admin/page'

import { useFlagcardContext } from 'app/contexts/flagcard'
import { ValidationError } from 'app/shared/types'
import MainLayout from 'layouts/main'
import sentimentControlSetsService, {
  UpdateSentimentControlSetRequest,
} from 'services/http/dataset/sentiment-control-set'
import { SentimentControlSet } from 'services/http/dataset/sentiment-control-set'

import { UpdateSentimentControlSetProps } from './types'
import SentimentControlSetForm from './SentimentControlSetForm'

const UpdateSentimentControlSet: React.FunctionComponent<UpdateSentimentControlSetProps> =
  ({ match, history }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isReady, setIsReady] = useState(true)
    const [sentimentControlSet, setSentimentControlSet] =
      useState<SentimentControlSet>()
    const [flagcard] = useFlagcardContext()

    useEffect(() => {
      const id = parseInt(match.params.id)

      sentimentControlSetsService
        .getById(id)
        .then((res) => {
          setSentimentControlSet(res.data)
        })
        .catch((err: Error) => {
          console.log(err)
        })
        .finally(() => {
          setIsReady(false)
        })
    }, [match.params.id, history])

    const handleSubmit = (data: UpdateSentimentControlSetRequest) => {
      if (data) {
        setIsLoading(true)

        sentimentControlSetsService
          .update(data)
          .then(() => {
            flagcard.add({
              id: uid(),
              appearance: 'success',
              title: 'İşlem Başarılı',
              children:
                'Geçerli veri, sistem üzerinde başarıyla güncellenmiştir.',
            })
          })
          .catch((error) => {
            console.log(error)

            flagcard.add({
              id: uid(),
              appearance: 'error',
              title: 'Hata Oluştu',
              children:
                'Geçerli veri güncellenirken bir hata oluştu. Lütfen tekrar deneyin. Sorununuz düzelmediyse servis sağlayıcısı ile iletişime geçiniz.',
            })
          })
          .finally(() => {
            setIsLoading(false)
          })
      }
    }

    const handleError = (error?: ValidationError) => {
      console.log(error)
    }

    const breadcrumbs = (
      <Breadcrumb>
        <BreadcrumbItem text="Anasayfa" href="/" />
        <BreadcrumbItem
          text="Duygu kontrol setleri"
          href="/sentiment-control-set"
        />
        <BreadcrumbItem text="Duygu kontrol seti güncelle" />
      </Breadcrumb>
    )

    return (
      <MainLayout isLoading={isReady}>
        <Container width="medium">
          <Page>
            <PageHeader
              // actions={<Button appearance="error">Delete user</Button>}
              breadcrumbs={breadcrumbs}
              bottomBar={
                <p>
                  Aşağıdaki bilgileri doldurarak geçerli duygu kontrol setini
                  güncelleyebilirsiniz.
                </p>
              }
            >
              Veri güncelleniyor:
              {sentimentControlSet ? sentimentControlSet.text : null}
            </PageHeader>
            <SentimentControlSetForm
              actions={
                <ButtonGroup>
                  <Button
                    appearance="primary"
                    children="Güncelle"
                    isLoading={isLoading}
                    type="submit"
                  />
                  <LinkButton href="/sentiment-control-set">İptal</LinkButton>
                </ButtonGroup>
              }
              operation="update"
              onSubmit={handleSubmit}
              onError={handleError}
              values={sentimentControlSet}
            />
          </Page>
        </Container>
      </MainLayout>
    )
  }

export default UpdateSentimentControlSet
